(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ww-product"] && !Shopify.designMode) return;
  try {
    
function initWW(){document.querySelectorAll('.ww-gallery').forEach(g=>{if(g.dataset.ready)return;g.dataset.ready='true';const track=g.querySelector('.ww-slides'),thumbs=[...g.querySelectorAll('[data-slide]')],counter=g.querySelector('.ww-counter');let current=0;function show(i){i=Math.max(0,Math.min(thumbs.length-1,i));track.scrollTo({left:i*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}thumbs.forEach(b=>b.addEventListener('click',()=>show(Number(b.dataset.slide))));g.querySelectorAll('[data-direction]').forEach(b=>b.addEventListener('click',()=>show(current+Number(b.dataset.direction))));track.addEventListener('scroll',()=>{current=Math.round(track.scrollLeft/track.clientWidth);counter.textContent=(current+1)+' / '+thumbs.length;thumbs.forEach((b,i)=>b.setAttribute('aria-current',String(i===current)));},{passive:true});track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(current+(e.key==='ArrowRight'?1:-1));}});thumbs[0].setAttribute('aria-current','true');});}initWW();document.addEventListener('shopify:section:load',initWW);

  } catch(e) { console.error(e); }
})();
})();
